import { ADDRESS_TYPE } from '@/components/steps/ShippingAddressStep/shippingSchema';
import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';
import { RFID_FLOW_NAME } from '@/features/orderNewCards/utils/analytics';

export const ONBOARDING_FLOW_NAME = 'onboarding';

export const trackStepView = (stepName: string) => {
    trackCustomEvent(
        'onboarding_step_view',
        {
            flow_name: ONBOARDING_FLOW_NAME,
            element_name: 'stepper',
            element_state: `${stepName}`,
            trigger: 'click',
        },
        createDebugConfig()
    );
};

export const trackStepAbandonment = (stepName: string) => {
    trackCustomEvent(
        'onboarding_step_abandonment',
        {
            flow_name: ONBOARDING_FLOW_NAME,
            element_name: 'stepper',
            element_state: `${stepName}`,
            trigger: 'visibility',
        },
        createDebugConfig()
    );
};

export const trackFlowComplete = (cardsRequested: number, hasCustomization: boolean) => {
    trackCustomEvent(
        'onboarding_complete',
        {
            flow_name: ONBOARDING_FLOW_NAME,
            element_name: hasCustomization ? 'complete_with_customization' : 'complete_without_customization',
            element_state: `${cardsRequested}`,
            trigger: 'click',
        },
        createDebugConfig()
    );
};

export const trackOnboardingCompleteMarketplace = () => {
    trackCustomEvent(
        'onboarding_complete_marketplace',
        {
            flow_name: ONBOARDING_FLOW_NAME,
            element_name: 'button',
            element_state: 'go_to_marketplace',
            trigger: 'click',
        },
        createDebugConfig()
    );
};

export const trackOnboardingCompleteOverview = () => {
    trackCustomEvent(
        'onboarding_complete_overview',
        {
            flow_name: ONBOARDING_FLOW_NAME,
            element_name: 'button',
            element_state: 'go_to_overview',
            trigger: 'click',
        },
        createDebugConfig()
    );
};

export const trackApplyToAllClick = (isOrderNewCard: boolean, line1: string) => {
    trackCustomEvent(
        'apply_to_all_click',
        {
            flow_name: isOrderNewCard ? RFID_FLOW_NAME : ONBOARDING_FLOW_NAME,
            element_state: line1,
            element_name: 'button',
            trigger: 'click',
        },
        createDebugConfig()
    );
};

export const trackSummarySubmit = (
    isOrderNewCard: boolean,
    hasRecipient: boolean,
    addressType?: (typeof ADDRESS_TYPE)[keyof typeof ADDRESS_TYPE]
) => {
    let elementState: string;

    if (addressType === ADDRESS_TYPE.individual) {
        elementState = ADDRESS_TYPE.individual;
    } else {
        elementState = hasRecipient ? 'company_with_recipient' : 'company_without_recipient';
    }

    trackCustomEvent(
        'shipping_address_summary_submit',
        {
            flow_name: isOrderNewCard ? RFID_FLOW_NAME : ONBOARDING_FLOW_NAME,
            element_name: 'shipping_address',
            element_state: elementState,
            trigger: 'click',
        },
        createDebugConfig()
    );
};
